<template lang="pug">
.s-vstack
  StatsGrowth(:api="api", :title="title", @select="select")
  GrowthByBiz(:result="growthByBiz")
</template>

<script>
import GrowthByBiz from "./GrowthByBiz.vue";

export default {
  components: { GrowthByBiz },
  data() {
    return {
      api: "/orders/messaging/stats/growth",
      title: "Messaging Growth",
      year: null,
      growthByBiz: [],
    };
  },
  methods: {
    select(year) {
      this.year = year;
      this.loadBiz();
    },
    // load growth by biz
    async loadBiz() {
      if (!this.year) return;
      const params = { year: this.year };
      try {
        const { data } = await this.axios.post(
          "/orders/messaging/stats/growth/biz",
          params
        );
        this.growthByBiz = data;
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
    },
  },
};
</script>
